module.exports = __webpack_public_path__ + "static/media/strong01.b9a4aebc.jpg";